import React, { useState, useRef, useEffect } from 'react';
import { FiMapPin, FiPhone, FiMail,  } from 'react-icons/fi';
import { CiInstagram } from "react-icons/ci";

function BuildingService() {
  const galleryImages = [
    "bbm-1", "bbm-2", "bbm-3",  "bbm-5",
    "bbm-6", "bbm-7",  "bbm-9", "bbm-a"
  ];

  const [visibleCount, setVisibleCount] = useState(6);

  return (
    <main className="main">

      {/* Page Title */}
      <div className="page-title dark-background">
        <div className="container text-center">
          <h1 className="page-heading">Building Materials</h1>
          <p className="page-subtitle">Supplying Strength to Your Structures</p>
          <nav className="breadcrumbs">
            <ol>
              <li><a href="/">Home</a></li>
              <li className="current">Service Details</li>
            </ol>
          </nav>
        </div>
      </div>

      {/* Service Details */}
      <section className="service-details section">
        <div className="container">

          {/* Main Image */}
          <div className="main-image-container">
            <img src="/assets/bbm/bbm-8.webp" alt="Building Materials" className="main-image" />
          </div>

          {/* Overview & Branch Profile */}
          <h2>Overview</h2>
          <p>
            Our Building Materials & Hardware Branch in Bahra provides a comprehensive range of essential construction 
            and maintenance products for residential, commercial, and industrial needs. From lighting solutions and pipes 
            to plumbing accessories, mirrors, washers, and related hardware materials, we offer reliable products that 
            meet high quality standards.
          </p>

          <h2>Branch Profile</h2>
          <p>
            Our branch serves as a reliable one-stop destination for high-quality construction and maintenance products in Saudi Arabia. 
            We supply a wide range of essential items and ensure customers receive the right materials exactly when they need them.
          </p>

          {/* Products Section */}
          <h2>Products</h2>

          <h3>Lighting Products</h3>
          <div className="product-row">
            LED bulbs, LED tube lights, Ceiling lights, Panel lights, Downlights, Spotlights, Flood lights, Street lights, Emergency lights, Decorative lights, Track lights, Wall-mounted lights, Garden/outdoor lights
          </div>

          <h3>Pipes & Fittings</h3>
          <div className="product-row">
            PVC pipes (all sizes), PVC elbows, PVC tees, PVC reducers, PVC couplings, PVC end caps, GI pipes, GI elbows, GI tees, GI unions, PEX pipes, PPR pipes, PPR elbows, PPR tees, PPR sockets
          </div>

          <h3>Plumbing Materials</h3>
          <div className="product-row">
            Water taps, Mixers, Shower heads, Hand showers, Hoses, Basin waste / Sink waste, Bottle traps, Plumbing valves, Angle valves, Gate valves, Ball valves, Pipe clamps, Water heaters, Toilet connectors
          </div>

          <h3>Bathroom & Sanitary Items</h3>
          <div className="product-row">
            Wash basins, Toilets, Toilet seats, Mirrors, Bathroom shelves, Soap holders, Towel holders, Tissue holders, Floor drains, Shower curtains, Bath accessories sets
          </div>

          <h3>Hardware Items</h3>
          <div className="product-row">
            Washers, Nuts & bolts, Screws, Wall plugs, Brackets, Hinges, Door locks, Padlocks, Door handles, Tools, Ladders, Measuring tapes, Sealants & adhesives
          </div>

          <h3>Building Materials</h3>
          <div className="product-row">
            Cement, Tile adhesives, Grout, Paints, Primers, Putty
          </div>

          <h3>Electrical Materials</h3>
          <div className="product-row">
            Switches, Sockets, Extension boards, Cables & wires, Distribution boards, Breakers, Cable ties, Conduits, Junction boxes
          </div>

          <h3>Other Supplies</h3>
          <div className="product-row">
            Cleaning materials, Brooms & mops, Buckets, Safety gloves, Safety helmets, Masks, Industrial tapes
          </div>

        </div>
      </section>

      {/* Gallery Section */}
      <section className="gallery-section">
        <div className="container">
          <h2 className="gallery-title">Gallery</h2>
          <div className="gallery-grid">
            {galleryImages.slice(0, visibleCount).map((img, index) => (
              <LazyImage 
                key={img} 
                src={`/assets/bbm/${img}.webp`} 
                alt={`Building Materials ${index + 1}`} 
                priority={index===0} 
              />
            ))}
          </div>

          {visibleCount < galleryImages.length && (
            <div className="load-more">
              <button onClick={() => setVisibleCount(v => v + 4)}>Load More</button>
            </div>
          )}
        </div>
      </section>

      {/* Location & Contact */}
      <section className="contact-strip">
        <div className="container">
          <h3 className="contact-heading">Location & Contact</h3>
          <div className="contact-row">
            <span><FiMapPin /> Old Makkah Jeddah road, Opp. Nahdi pharmacy, Bahrah mujahidin Al Junubiya</span>
            <span><FiPhone /> 0502022626</span>
            <span><FiPhone /> +966 546725394</span>
          <a href="mailto:build@almaccompany.com">
  <FiMail />
  build@almaccompany.com
</a>

            <a
                           href="https://www.instagram.com/almac_company?igsh=MThmemIyN2d6aG8zeQ=="
                           target="_blank"
                           rel="noopener noreferrer"
                         >
                           <CiInstagram style={{ fontSize: '40px', color: '#fff', cursor: 'pointer' }} />
                         </a>
          </div>
        </div>
      </section>

      {/* Styles */}
      <style>{`
        /* Headings */
        .page-heading { font-size: 3rem; font-weight: 800; color:#fff; text-shadow:2px2px5px rgba(0,0,0,0.6); margin-bottom:10px; }
        .page-subtitle { font-size:1.2rem; color:#e6e6e6; margin-bottom:15px; }
        h2 { font-size:2rem; margin-top:30px; margin-bottom:15px; color:#222; }
        h3 { font-size:1.6rem; margin-top:25px; margin-bottom:12px; color:#333; }
        h4 { font-size:1.3rem; margin-top:15px; margin-bottom:8px; color:#555; }

        /* Paragraphs & Products */
        p, .product-row { font-size:1.1rem; line-height:1.8; color:#555; margin-bottom:12px; }
        .product-row { display:flex; flex-wrap:wrap; gap:12px; }

        /* Main Image */
        .main-image-container { text-align:center; margin-bottom:35px; }
        .main-image { width:100%; max-width:900px; height:auto; border-radius:12px; }

        /* Gallery */
        .gallery-title { text-align:center; font-size:2rem; margin-bottom:25px; }
        .gallery-grid {
          display:grid;
          grid-template-columns:repeat(auto-fit,minmax(230px,1fr));
          gap:15px;
          margin-top:20px;
        }
        .img-wrapper { width:100%; height:220px; border-radius:12px; overflow:hidden; background:#f2f2f2; }
        .img-wrapper img { width:100%; height:100%; object-fit:cover; transition:transform 0.25s ease; }
        .img-wrapper:hover img { transform:scale(1.04); }
        .load-more { text-align:center; margin-top:20px; }
        .load-more button { padding:10px 25px; border-radius:30px; border:none; background:#111; color:#fff; cursor:pointer; font-size:14px; }

        /* Contact */
        .contact-strip { background:#fafafa; border-top:1px solid #eee; margin-top:50px; padding:40px 0; }
        .contact-heading { text-align:center; font-size:1.7rem; margin-bottom:20px; font-weight:700; color:#222; }
        .contact-row { display:flex; justify-content:center; align-items:center; gap:25px; flex-wrap:wrap; font-size:1rem; color:#333; }
        .contact-row span, .contact-row a { display:flex; align-items:center; gap:8px; text-decoration:none; font-weight:500; white-space:nowrap; color:#333; }
        .contact-row svg { font-size:1.3rem; color:#111; }

        @media(max-width:991px){
          .product-row { font-size:1rem; gap:8px; }
        }
        @media(max-width:576px){
          .product-row { flex-direction:column; gap:5px; }
          .gallery-grid { grid-template-columns:repeat(auto-fit,minmax(200px,1fr)); }
        }
      `}</style>
    </main>
  );
}

/* LazyImage Component */
function LazyImage({ src, alt, priority }) {
  const ref = useRef(null);
  const [show, setShow] = useState(priority);

  useEffect(() => {
    if (priority) return;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setShow(true);
        observer.disconnect();
      }
    }, { rootMargin: "150px" });
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [priority]);

  return (
    <div className="img-wrapper" ref={ref}>
      {show && <img src={src} alt={alt} loading={priority ? "eager" : "lazy"} />}
    </div>
  );
}

export default BuildingService;
